module.exports = __webpack_public_path__ + "static/media/sheik_0.d944ff1e.png";